import { ScheduleJobMatchItemComponent } from "./schedule-job-match-item.component";
import { ScheduleJobMatchItemActionsModalComponent } from "./scheduleJobMatchItemActionsModal/schedule-job-match-item-actions-modal.component";
export const ScheduleJobMatchItemModule = angular
    .module('scheduleJobMatchItem', [])
    .component(ScheduleJobMatchItemComponent.selector, ScheduleJobMatchItemComponent.component)
    .component(ScheduleJobMatchItemActionsModalComponent.selector, ScheduleJobMatchItemActionsModalComponent.component)
    .name;
//# sourceMappingURL=schedule-job-match-item.module.js.map